export const config = {
//api endpoitns accross web Backend

baseURL:"https://legaldocumentgenerator.com/Backend",
//baseURL:"http://localhost/",

title: 'Ai Legal Document Generator',
color:'#FF3A12',


//Left Panel Icons visible on Wider Screen ex.PC ,
home_leftPanel: require('./assets/home.svg').default,
history_leftPanel: require('./assets/history.svg').default,
privacy_leftPanel: require('./assets/privacy.svg').default,
refund_leftPanel: require('./assets/refund.svg').default,
terms_leftPanel: require('./assets/terms.svg').default,
blogs_leftPanel: require('./assets/blogs.svg').default,
close_button_x: require('./assets/close_x.svg').default,
templateslp:require('./assets/templateslp.svg').default,



// Dashboard Button and cards icon
createLegal: require('./assets/createLegal.svg').default,
caseSummarizer: require('./assets/caseSummarizer.svg').default,
aiAssistant: require('./assets/aiAssistant.svg').default,
buyPremium: require('./assets/buyPremium.svg').default,
leaseAgreement: require('./assets/leaseAgreement.png'),
card_button1: require('./assets/card_button1.png'),
card_button4: require('./assets/card_button4.png'),
card_button5: require('./assets/card_button5.png'),
card_button6: require('./assets/card_button6.png'),
card_button7: require('./assets/card_button7.png'),
card_button8: require('./assets/card_button8.png'),
card_button9: require('./assets/card_button9.png'),
card_button10: require('./assets/card_button10.png'),
card_button11: require('./assets/card_button11.png'),
card_button12: require('./assets/card_button12.png'),
card_button13: require('./assets/card_button13.png'),
card_button3: require('./assets/card_button3.png'),
card_button2: require('./assets/card_button2.png'),
criminalcharges:require('./assets/criminalcharges.svg').default, 
employmentContract:require('./assets/employmentContract.png'),
propertyOwnership:require('./assets/propertyOwnership.png'),
nonCriminalCertificate:require('./assets/nonCriminalCertificate.png'),
buy_btn_dashboard: require('./assets/buy_btn_dashboard.svg').default,
ask_button1: require('./assets/ask_button1.png'),
ask_button2: require('./assets/ask_button2.png'),
ask_button3: require('./assets/ask_button3.png'),
ask_button4: require('./assets/ask_button4.png'),
ask_button5: require('./assets/ask_button5.png'),
ask_button6: require('./assets/ask_button6.png'),
ask_button7: require('./assets/ask_button7.png'),
ask_button8: require('./assets/ask_button8.png'),
ask_button9: require('./assets/ask_button9.png'),
ask_button10: require('./assets/ask_button10.png'),
ask_button11: require('./assets/ask_button11.png'),



  //Random Images used accross web
  logo: require('./assets/vector.svg').default,
  buyP: require('./assets/Group 1437252828.svg').default,
  crossimg: require('./assets/cross_img.svg').default,
  crossimgWhite: require('./assets/cross_imgWhite.svg').default,
  crown: require('./assets/crown 1.svg').default,
  menuDropDown:require('./assets/menuDropDown.svg').default,
  generate: require('./assets/generate.svg').default,
  proicon: require('./assets/pro.svg').default,
  upgradetopro: require('./assets/upgradetopro.png')  ,
  righticon: require('./assets/right.svg').default,
  Backbutton: require('./assets/backButton.svg').default,
  backButtonWhite: require('./assets/backButtonWhite.svg').default,
  Buybutton: require('./assets/arrow long right.svg').default,
  Outline_1: require('./assets/Outline_1.svg').default, 
  Outline_2: require('./assets/Outline_2.svg').default, 
  Outline_3: require('./assets/Outline_3.svg').default, 
  colored_check_point: require('./assets/checkpoints.svg').default, 
  check_point: require('./assets/check_white.svg').default, 
  sendButton: require('./assets/sendButton.svg').default,
  rightArrow:require('./assets/rightArrow.svg').default,
  editIcon:require('./assets/editIcon.svg').default,
  leaseRecommanded: require('./assets/leaseRecommanded.png'),
  marriageRecommanded: require('./assets/marriageAssistant.png'),
  mutualRecommanded: require('./assets/mutualNDA.png'),
  divorceRecommanded: require('./assets/divorce.png'),
  aiAvatar: require('./assets/aiAvatar.png'),








  // logolanding: require('./assets/logolanding.svg').default,
  check_point_white: require('./assets/check_white.svg').default,
  check_point_locked_white: require('./assets/check_point_locked.svg').default,
  pdfRed: require('./assets/pdfIcon.svg').default,
  menuRed: require('./assets/menuRed.svg').default,
  pdfWhite: require('./assets/pdfIcon.png'),
  proIcon: require('./assets/proIcon.svg').default,
  playTTS: require('./assets/playTTS.svg').default,
  stopTTS: require('./assets/stopTTS.svg').default,
  darkMode: require('./assets/darkMode.svg').default,
// Hamburger Slider Buttons Icon
  hamburger: require('./assets/Icon_Hamburger.svg').default,
  homeSlider: require('./assets/filled leftp.svg').default,
  privacySlider: require('./assets/description leftp.svg').default,  
  termsSlider: require('./assets/termsSlider.svg').default,
  refundSlider: require('./assets/refundSlider.svg').default,


  
  

 // Share and Copy Buttons
  shareButton:require('./assets/shareButton.svg').default,
  copyButton:require('./assets/copyButton.svg').default,
  shareButtonWB:require('./assets/shareButtonWB.svg').default,
  copyButtonWB:require('./assets/copyButtonWB.svg').default,  

  //Footer Icon set
  homeFooter:require('./assets/homeFooter.svg').default,  
  historyFooter:require('./assets/historyFooter.svg').default,  
  templatesFooter:require('./assets/templatesFooter.svg').default,  
  uploadFile:require('./assets/uploadFile.svg').default,  

  //Form page icons
  uploadedDoc:require('./assets/uploadedDoc.svg').default,  
  fileUpload:require('./assets/fileUpload.svg').default,  


 



//Landing Page icon sets
  Heroimage: require('./assets/heroimg.svg').default,
  Herotitleborder: require('./assets/Herotitleborder.svg').default,
  reviewstarimg1: require('./assets/reviewstarimg1.svg').default,
  reviewstarimg2: require('./assets/reviewstarimg2.svg').default,
  hero2ndpartimg1: require('./assets/hero2ndpartimg1.svg').default,
  hero2ndpartimg2: require('./assets/hero2ndpartimg1.svg').default,
  hero2ndpartimg3: require('./assets/hero2ndpartimg1.svg').default,
  templatesdefault0: require('./assets/templatesplaceholder.png'),
  templatesdefault1: require('./assets/templatesplaceholder1.png'),
  templatesdefault2: require('./assets/templatesplaceholder2.png'),
  stepline: require('./assets/stepLine.svg').default,
  step1: require('./assets/step1.svg').default,
  step2: require('./assets/step2.svg').default,
  step3: require('./assets/step3.svg').default,
  step4: require('./assets/step4.svg').default,
  





  //privacy page 
    "privacyTitle": "Privacy Policy for Ai Legal Document Generator",
    "privacyEffectiveDate": "13-7-2023",
    "privacyPoints": [
      {
        "heading": "1. Information We Collect",
        "subsections": [
          {
            "heading": "1.1 Personal Information",
            "content": [
              "We may collect personal information that you provide directly to us when using the App. This includes:",
              "- Your name, email address, and other contact information when you sign up or contact us for support.",
              "- Story content and other user-generated content you provide within the App.",
              "- Communication and interaction details when you communicate with other users or us through the App."
            ]
          },
          {
            "heading": "1.2 Usage Information",
            "content": [
              "When you use the App, we may automatically collect certain information about your device and usage patterns, including:",
              "- Device information (such as model, operating system version, unique device identifiers).",
              "- Log information (such as IP address, access dates and times, and referring/exit pages).",
              "- App usage data, including the features you use, the pages you visit, and the actions you take."
            ]
          }
        ]
      },
      {
        "heading": "2. Use of Information",
        "subsections": [
          {
            "heading": "2.1 Provide and Improve the App",
            "content": [
              "We use the collected information to provide, maintain, and improve the functionality and performance of the App. This includes:",
              "- Personalizing your experience and providing you with tailored content.",
              "- Enhancing the App's security and detecting, preventing, and responding to potential fraud or security issues."
            ]
          }
        ]
      },
      {
        "heading": "3. Sharing Your Information",
        "content": [
          "- We do not share your personal information with third parties, except as required by law or with your explicit consent."
        ]
      }
    ],




    "termandcondition": "Terms of Use Policy for Ai Legal Document Generator ",
  "termandconditionEffectiveDate": "16-12-2024",
  "termandconditionPoints": [
    {
      "heading": "1. Introduction",
      "content": [
        "Welcome to our Ai Legal Document Generator ! These terms of use outline the rules and regulations for the use of our mobile applications powered by AI technology. By accessing or using our apps, you agree to comply with these terms and conditions. If you do not agree with any part of these terms, you may not access or use our apps."
      ]
    },
    {
      "heading": "2. License",
      "content": [
        "Our apps are licensed to you on a limited, non-exclusive, non-transferable, and revocable basis. You may use our apps solely for your personal, non-commercial purposes and in accordance with these terms."
      ]
    },
    {
      "heading": "3. Restrictions",
      "subsections": [
        {
          "heading": "3.1 General Restrictions",
          "content": [
            "When using our apps, you must not:",
            "- Violate any applicable laws or regulations.",
            "- Infringe upon the rights of others.",
            "- Introduce any malicious code or software.",
            "- Attempt to gain unauthorized access to our apps or any related systems or networks.",
            "- Interfere with the proper functioning of our apps."
          ]
        }
      ]
    },
    {
      "heading": "4. Intellectual Property",
      "content": [
        "All intellectual property rights in our apps, including but not limited to copyrights, trademarks, and patents, are owned by us or our licensors. You may not reproduce, modify, distribute, or otherwise use any of our intellectual property without our prior written consent."
      ]
    },
    {
      "heading": "5. Privacy",
      "content": [
        "We respect your privacy and are committed to protecting your personal information. Our Privacy Policy explains how we collect, use, and disclose your information when you use our apps. By using our apps, you consent to the collection, use, and disclosure of your information as described in our Privacy Policy."
      ]
    },
    {
      "heading": "6. Disclaimer",
      "content": [
        "Our apps are provided on an ‘as is’ and ‘as available’ basis. We make no warranties or representations of any kind, whether expressed or implied, regarding the operation or availability of our apps, or the accuracy, reliability, or completeness of any information provided through our apps."
      ]
    },
    {
      "heading": "7. Limitation of Liability",
      "content": [
        "In no event shall we be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with the use of our apps. You agree to indemnify and hold us harmless from any claims, losses, or damages, including legal fees, arising out of your use of our apps or any violation of these terms."
      ]
    },
    {
      "heading": "8. Changes to Terms",
      "content": [
        "We reserve the right to modify or update these terms of use at any time. Any changes will be effective immediately upon posting the updated terms on our website. It is your responsibility to review these terms periodically for any changes."
      ]
    },
    {
      "heading": "9. Contact Us",
      "content": [
        "If you have any questions or concerns about these terms of use, please contact us at speedapps1010@gmail.com."
      ]
    }
  ],
  "refundTitle": "Refund & Cancellation Policy",
  "refundEffectiveDate": "15th August 2024",
  "refundPoints": [
    {
      "heading": "1. Refund Policy",
      "subsections": [
        {
          "heading": "1.1 Subscription Products",
          "content": [
            "Ai Legal Document Generator provides digital products and services in the form of subscriptions. Due to the nature of our offerings, we maintain the following refund guidelines:",
            "- **Trial Periods**: If your subscription plan includes a trial period, you may cancel at any time during the trial to avoid charges. Refunds will not be applicable if the subscription is canceled after the trial period ends and the payment has been processed.",
            "- **30-Day Money-Back Guarantee**: We offer a 30-day money-back guarantee for first-time users. If you are not satisfied with our service, you may request a refund within 30 days of your initial purchase. After 30 days, no refunds will be issued.",
            "- **Refund Eligibility**: To be eligible for a refund, your request must meet the following conditions:",
            "  - The request is made within 30 days of the initial purchase.",
            "  - You must provide a valid reason for the refund request, such as technical issues with the software that cannot be resolved.",
            "- **Non-Refundable Subscriptions**: Subscription renewals are non-refundable. You can cancel your subscription at any time to prevent future charges, but refunds for renewal payments will not be issued.",
            "- **Exclusions**: Refunds are not applicable for:",
            "  - Any product purchased with a promotional discount or code.",
            "  - Multi-user or team licenses."
          ]
        },
        {
          "heading": "1.2 Process for Refund Requests",
          "content": [
            "To request a refund, please contact our customer support team at [support@aispeedapps.com] with your order details and the reason for your request. Refunds will be processed within 7-10 business days after approval. Funds will be credited back to the original payment method."
          ]
        }
      ]
    },
    {
      "heading": "2. Cancellation Policy",
      "subsections": [
        {
          "heading": "2.1 Canceling Subscriptions",
          "content": [
            "You can cancel your subscription at any time by logging into your Ai Legal Document Generator account and navigating to the 'Subscriptions' section. Simply follow the cancellation instructions provided.",
            "- **Immediate Effect**: Once canceled, your subscription will not be renewed. You will continue to have access to the software until the end of your current billing cycle. After that period, your access to the software will be revoked.",
            "- **Future Billing**: If you cancel your subscription, you will not be charged for the next billing cycle. However, there are no prorated refunds for mid-cycle cancellations; you will have access until the current subscription period ends."
          ]
        },
        {
          "heading": "2.2 Involuntary Cancellations",
          "content": [
            "Ai Legal Document Generator reserves the right to suspend or terminate your subscription at any time due to violations of our Terms of Service or any other breach of agreement. In such cases, no refunds will be issued."
          ]
        }
      ]
    },
    {
      "heading": "3. Contact Us",
      "content": [
        "If you have any questions or need assistance with your refund or cancellation, please reach out to our customer support team at:",
        "- **Ai Legal Document Generator Support Team**",
        "- **Email**: speedapps1010@gmail.com",
        "- **Phone**: 8176851179",
        "- **Website**: [https://aiacademicswriter.com/]"
      ]
    },
    {
      "heading": "4. Changes to This Policy",
      "content": [
        "Ai Legal Document Generator reserves the right to modify this Refund & Cancellation Policy at any time. Any changes will be posted on our website and will take effect immediately. It is your responsibility to review this policy periodically."
      ]
    }
  ]
  };
